const initialState = {
  value: '012345678910',
};

const passwordDefaultReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PASS':
      return {
        ...state,
        value: action.value,
      };
    default:
      return state;
  }
};

export default passwordDefaultReducer;
